import { createContext } from 'react';
import Company from '../types/company';

const CurrentCompanyContext = createContext<Company | undefined>(undefined);

export { CurrentCompanyContext };
